export default __webpack_public_path__ + "static/media/close-icon.e94e0ec0.svg";